import { CircularProgress } from "@mui/material";
import useDashboard from "./view/useDashboard";

const Dashboard = () => {
  const { myAccess, isLoading, onItemClick } = useDashboard();

  return (
    <div className="px-20 pt-5 mt-10  ">
      {isLoading ? (
        <div className="flex justify-center py-[10rem]">
          <CircularProgress size={75} />
        </div>
      ) : (
        <div className="fadeInBottom">
          <h1 className="text-black text-2xl font-semibold">
            Welcome to Notification Preference 👋
          </h1>
          <p className="my-2 mb-8">Choose a business unit to get started.</p>
          <div className="mt-4 grid grid-cols-4 2xl:grid-cols-5 gap-10">
            {myAccess
              .sort((a, b) => a.label.localeCompare(b.label))
              .map((item) => (
                <div
                  key={item.label}
                  className="w-[260px] h-[240px] bg-white cursor-pointer flex justify-center flex-col items-center card-box-shadow"
                  onClick={() => {
                    onItemClick(item);
                  }}
                >
                  <img
                    src={item.img}
                    height={128}
                    width={128}
                    alt={`logo of ${item.label}`}
                    className="h-[128px] w-[128px] aspect-video rounded-full"
                  />
                  <div className="text-black mt-8 text-xl font-semibold text-opacity-55 capitalize text-center break-words text-wrap line-clamp-2">
                    {item.label}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
